import type { IPagination } from "../../../../../types/models/pagination.models.types";
import { useGetHttp } from "../../../http.hook";
import type { IPayoutMethod } from "./add-bank-account.admin.http";

interface IResponse {
  payoutMethods: IPayoutMethod[];
  pagination: IPagination;
}

export function useGetAllPayoutMethodsHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/vendors/payouts/:vendorId",
  });
}
